/* TypeScript file generated from Inline.resi by genType. */

/* eslint-disable */
/* tslint:disable */

import * as InlineJS from './Inline.res.js';

import type {Style_t as StyleX_Style_t} from '../../../src/externals/StyleX.gen';

import type {t as Spaces_t} from '../../../src/resources/theme/Spaces.gen';

export type align = 
    "center"
  | "start"
  | "end"
  | "spaceAround"
  | "spaceBetween";

export type alignY = 
    "center"
  | "top"
  | "bottom"
  | "stretch"
  | "baseline";

export type props<children,space,align,alignY,grow,fullWidth,wrap,shrink,stylex> = {
  readonly children: children; 
  readonly space?: space; 
  readonly align?: align; 
  readonly alignY?: alignY; 
  readonly grow?: grow; 
  readonly fullWidth?: fullWidth; 
  readonly wrap?: wrap; 
  readonly shrink?: shrink; 
  readonly stylex?: stylex
};

export const make: React.ComponentType<{
  readonly children: React.ReactNode; 
  readonly space?: Spaces_t; 
  readonly align?: align; 
  readonly alignY?: alignY; 
  readonly grow?: boolean; 
  readonly fullWidth?: boolean; 
  readonly wrap?: boolean; 
  readonly shrink?: boolean; 
  readonly stylex?: StyleX_Style_t
}> = InlineJS.make as any;
